// Array of EEA countries
import { useHeaderFooter } from '@cdc-internal/mkt-header-footer'

export const EEA_COUNTRIES = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
  'NO', // Norway
  'IS', // Iceland
  'FR', // France
  'IT', // Italy
]

// Array of GCC countries
export const GCC_COUNTRIES = [
  'BH', // Bahrain
  'KW', // Kuwait
  'OM', // Oman
  'QA', // Qatar
  'SA', // Saudi Arabia
]
const ipCountryMap: Record<string, string> = {
  // North America
  US: 'US',
  CA: 'CA',

  // Europe
  FR: 'FR',
  IT: 'IT',
  GB: 'UK',
  TR: 'TR',

  AE: 'AE',
  // EEA Countries
  ...Object.fromEntries(EEA_COUNTRIES.map(country => [country, 'EEA'])),

  // GCC Countries
  ...Object.fromEntries(GCC_COUNTRIES.map(country => [country, 'GCC'])),

  // Others
  SG: 'SG', // Singapore
  BR: 'BR', // Brazil
  AU: 'AU', // Australia
  KR: 'KR', // South Korea
}

/**
 * keep the same logic from frontend-mkt-content-hub
 */
export const getRegionByCountry = (
  country: string,
): Parameters<typeof useHeaderFooter>[0]['region'] => {
  return (ipCountryMap[country]?.toLowerCase() as any) ?? 'global'
}

const FLAG_IMAGE_PATH_DOMAIN = 'https://mkt-site-asset.crypto.com/assets/country-icon'

export const getCurrencyFlagUrl = (currency: string): string => {
  const currencyIconCodeMap: Record<string, string> = {
    AUD: 'AU',
    BRL: 'BR',
    CAD: 'CA',
    EUR: 'EU',
    GBP: 'UK',
    HKD: 'HK',
    KRW: 'KR',
    RUB: 'RU',
    SGD: 'SG',
    TWD: 'TW',
    USD: 'US',
  }
  const formattedCode = currencyIconCodeMap[currency] || 'GLOBAL'
  return `${FLAG_IMAGE_PATH_DOMAIN}/flag-${formattedCode.toLowerCase()}.webp`
}

/**
 * TODO: for Country Code KR,we need force redirect it's path to kr, if the path is not kr or en-kr.
 * After implement it, could remove the params countryCode
 */
/**
 * Check if the given locale represents a Korean region
 * @param locale - The locale string to check
 * @param countryCode - The code from X-Forwarded-Country
 * @returns true if the locale is 'kr' or 'en-kr', false otherwise
 */
export const isKoreanRegion = (locale: string, countryCode: string): boolean => {
  return locale === 'kr' || locale === 'en-kr' || countryCode === 'KR'
}

export const isEEARegion = (locale: string, countryCode: string): boolean => {
  return locale === 'eea' || EEA_COUNTRIES.includes(countryCode)
}

/**
 * Check if user is in a restricted region based on region restrictions from API
 * @param regionRestrictions - Array of restricted region codes from API (e.g., ['EEA', 'UK', 'US'])
 * @param countryCode - The user's country code
 * @param locale - The user's locale
 * @returns true if user is in a restricted region
 */
export const isUserInRestrictedRegion = (
  regionRestrictions: string[] | undefined,
  countryCode: string,
  locale: string,
): boolean => {
  if (!regionRestrictions || regionRestrictions.length === 0) {
    return false
  }

  for (const restriction of regionRestrictions) {
    const upperRestriction = restriction.toUpperCase()
    if (upperRestriction === 'EEA' && isEEARegion(locale, countryCode)) {
      return true
    }
  }

  return false
}
